// import moment from 'moment'
export const users = [
    {
        id: 1,
        name: "Alice Blue",
        email: "aliceblue@example.com",
        avatar: require('@/assets/images/users/1.jpg'),
        phone: "+918520154870",
        company: "Google",
        is_important: true,
        is_recent: true,
        selected: false
    },
    {
        id: 2,
        name: "Jack Johnson",
        email: "jack@example.com",
        avatar: require('@/assets/images/users/2.jpg'),
        phone: "+919874563215",
        company: "Apple",
        is_important: false,
        is_recent: false,
        selected: false
    },
    {
        id: 3,
        name: "Bruce Canta",
        email: "bruce@example.com",
        avatar: require('@/assets/images/users/3.jpg'),
        phone: "+919456874560",
        company: "HCL Technologies",
        is_important: true,
        is_recent: false,
        selected: false
    },
    {
        id: 4,
        name: "Camelia Lopez",
        email: "camelia@example.com",
        avatar: require('@/assets/images/users/4.jpg'),
        phone: "+914851236450",
        company: "Infosys",
        is_important: true,
        is_recent: true,
        selected: false
    },
    {
        id: 5,
        name: "Denis Richard",
        email: "denis@example.com",
        avatar: require('@/assets/images/users/5.jpg'),
        phone: "+811451203654",
        company: "Wipro",
        is_important: false,
        is_recent: false,
        selected: false
    },
    {
        id: 6,
        name: "Mia Willson",
        email: "mia@example.com",
        avatar: require('@/assets/images/users/6.jpg'),
        phone: "+154579602123",
        company: "Oracle Financial Services Software",
        is_important: true,
        is_recent: false,
        selected: false
    }
];

export const authUser = users[0];

